export const contentToEbookTrack = (content) => {
    return ({
        url: content.asset.src,
        initialLocation: undefined,
    });
};
//# sourceMappingURL=contentToEbookTrack.js.map